import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Modal from 'react-responsive-modal';

import content from './content';
import './customerCard.css';

import { connectProps } from 'store';
import { langProp } from 'model/component-props';


class CustomerCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    onOpenModal = () => {
        this.setState({ open: true });
      };
     
      onCloseModal = () => {
        this.setState({ open: false });
      };

    render(){
        const { Name, No, Address, City, Post_Code, Phone_No, Outstanding_Orders, Balance_LCY, Currency_Code, langProp } = this.props;
        const { open } = this.state;
        return (
            <div>
                <Card onClick={this.onOpenModal} className='customerCard'>
                    <CardContent>
                        <div className="container-text">
                            <div className="id">{No}</div>
                            <span className="brand-customer">{Name}</span>
                            <div colSpan="2" className="balance-customer">{parseFloat(Balance_LCY).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {Currency_Code}</div>
                        </div>
                    </CardContent>
                </Card>
                <div>
                    <Modal 
                        open={open} 
                        onClose={this.onCloseModal} 
                        closeOnEsc={true} 
                        closeOnOverlayClick={true}
                        closeIconSize={40}
                        showCloseIcon={true} 
                        center>
                        <div className="container-content">
                            <CardContent className="address-field">
                                <div>
                                    <div className="title">
                                        <div className="title-container">
                                            <div className="title-text">{No}</div>
                                            <div className="title-text">{Name}</div>
                                        </div>
                                    </div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="modal-text">{content[langProp].Balance_LCY}</td>
                                                <td>{parseFloat(Balance_LCY).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="3" className="modal-text">{content[langProp].Address}:  </td>
                                                <td className="customer-text">{Address}</td>
                                            </tr>
                                            <tr>
                                                <td className="customer-text">{City}</td>
                                            </tr>
                                            <tr>
                                                <td className="customer-text">{Post_Code}</td>
                                            </tr>
                                            <tr>
                                                <td className="modal-text">{content[langProp].Phone_No}:  </td>
                                                <td className="customer-text">{Phone_No}</td>
                                            </tr>
                                            <tr>
                                                <td className="modal-text">{content[langProp].Orders}:  </td>
                                                <td className="customer-text">{parseFloat(Outstanding_Orders).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </CardContent>
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default connectProps(langProp)(CustomerCard);



// WEBPACK FOOTER //
// ./src/components/customercard/CustomerCard.js